import { Directive, inject, Input, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[libCustomHost]',
    standalone: false
})
export class CustomHostDirective {
  public viewContainerRef = inject(ViewContainerRef);
  
  @Input() name = '';
}
